import React from 'react';

import styled from 'styled-components';

import ActionCenterItems from './ActionCenterItems';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
`;

const Description = styled.div`
  max-width: 760px;
  margin-top: 7px;
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
`;

const TitleContainer = styled.div`
  height: 55px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TitleIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: var(--competitor-purple);
  box-shadow: 0 2px 4px 0 var(--box-shadow-pink);
`;

const TitleIconImage = styled.img`
  width: 22px;
  height: 22px;
`;

const Title = styled.div`
  height: 40px;
  font-family: var(--font-bold);
  font-size: 40px;
`;

const Content = styled.div`
  padding: 14px 30px 24px;
`;

const ActionsPanel = styled.section`
  width: 100%;
  max-width: 760px;
  overflow: hidden;
  border: 1px solid var(--line-gray);
  border-radius: 12px;
  background: var(--white);
`;

const ActionCenterPage = () => {
  return (
    <Container>
      <Header>
        <TitleContainer>
          <TitleIcon>
            <TitleIconImage src="/icons/checklist-white.svg" alt="Action Center" />
          </TitleIcon>
          <Title>Action Center</Title>
        </TitleContainer>
        <Description>
          Review and complete items that need your attention.
          <br />
          Action Center brings important follow-ups together in one place so you can quickly see what needs to be done.
        </Description>
      </Header>
      <Content>
        <ActionsPanel>
          <ActionCenterItems enabled />
        </ActionsPanel>
      </Content>
    </Container>
  );
};

export default ActionCenterPage;
